<template>
<div>

    <el-crud :baseUrl="'/rosters'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        ref="crud">

        <template slot="table">
            <el-table-column
                prop="company_id_number"
                label="Cód.">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Nombre">
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Código" label-width="120px" :prop="resource.company_id_number" :error="scope.errors.company_id_number">
                <el-input v-model="resource.company_id_number" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Nombre" label-width="120px" :prop="resource.description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off" size="mini"></el-input>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nueva Nómina',
                    EditItemTitle: 'Editar Nómina',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente la nómina. Desea continuar?'
                },
                resource:{
                    company_id_number: null,
                    description: null,
                },
            }
        },
        components: {
            'el-crud': el_crud,
        },
    }
</script>
